import React from "react";

const TeamMember = ({ teamMember }) => {
  const { id, name, avatar } = teamMember || {};
  return (
    <div className="checkbox-container">
      <img
        src={require(`../../assets${avatar}`)}
        className="team-avater"
        alt={name}
      />
      <p className="label">{name}</p>
    </div>
  );
};

export default TeamMember;
